import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Visibility, Assignment } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { Link } from 'react-router-dom';

import ButtonDelete from 'hooks/ButtonDelete';
import { wsGetAll } from 'services/WService';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'ID', accessor: 'dni' },
  { Header: 'Nombres', accessor: 'name' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function User(props) {
  const classes = useStyles();

  const [users, setUsers] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listUsers() {
    setDataLoading(true);
    let response = await wsGetAll('prt/document/users');
    setDataLoading(false);
    if (response.success) setUsers(response.data);
  }

  useEffect(() => {
    listUsers();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de usuarios {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Usuarios-impresión"
              defaultWidth={1000}
              indexRow={[0, 3]}
              widthRow={[120, 5]}
              columns={columns}
              data={users.map((user, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.PRT_DOCUMENTS_SHOW}>
                        <Button justIcon round simple style={{ width: '24px', height: '24px' }}>
                          <Link to={`${user.id}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>

                      {/* <ButtonDelete
                    entity="prt/user"
                    id={user.id}
                    reload={listUsers}
                  /> */}
                    </div>
                  ),
                  dni: user.id,
                  name: user.name,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
